import styled from 'styled-components';
import { Icon } from 'components/icon';
import { CardType } from 'types';
import { ReactComponent as Mastercard } from 'assets/payment-brands/mastercard.svg';
import { ReactComponent as Visa } from 'assets/payment-brands/visa.svg';
import { ReactComponent as Amex } from 'assets/payment-brands/amex.svg';
import { ReactComponent as Discover } from 'assets/payment-brands/discover.svg';
import { ReactComponent as UnionPay } from 'assets/payment-brands/unionpay.svg';

const brandLogos = {
  [CardType.Mastercard]: <Mastercard />,
  [CardType.Visa]: <Visa />,
  [CardType.AmericanExpress]: <Amex />,
  [CardType.Discover]: <Discover />,
  [CardType.UnionPay]: <UnionPay />,
};
import { EventCheckout } from 'store/api/event';
import { formatPrice } from 'utils/helpers';
import { getReceiptPaymentDetails } from './payment-lines';

const Methods = styled.div`
  display: flex; flex-direction: column; gap: 8px; min-width: 0; width: 100%;
`;
const Method = styled.div`
  display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
  font-variant-numeric: tabular-nums;
`;
const Logo = styled.span`
  width: 46px; height: 30px; flex-shrink: 0; display: inline-flex;
  align-items: center; justify-content: center; background: #fff;
  border: 1px solid #e5e7eb; border-radius: 6px;
  svg { width: 40px; height: 26px; }
`;
const Identity = styled.span`
  display: inline-flex; align-items: center; gap: 8px; white-space: nowrap;
`;
const Amount = styled.span`
  font-weight: 600; white-space: nowrap;
`;
export function ReceiptPaymentMethods({checkout}: {checkout?: EventCheckout}) {
  return <Methods>{getReceiptPaymentDetails(checkout).map((payment,index) =>
    <Method key={index} aria-label={payment.label + (payment.last4 ? ' ending in ' + payment.last4 : '') + ', ' + formatPrice(payment.amount)}>
      <Identity>
        {payment.isCard && <Logo role="img" aria-label={payment.brand ? payment.label : 'Credit card'}>
          {payment.brand ? brandLogos[payment.brand] : <Icon.CreditCard />}
        </Logo>}
        {payment.isCard && payment.last4 ? <span>•••• {payment.last4}</span> : <span>{payment.label}</span>}
      </Identity>
      <Amount>{formatPrice(payment.amount)}</Amount>
    </Method>
  )}</Methods>;
}
